<template>
  <div
    class="kft-faq-container"
    itemscope
    itemtype="https://schema.org/FAQPage"
  >
    <!--begin::Accordion-->
    <div
      v-for="(section, i) in content"
      :key="`kft-faq-${i}`"
      class="kft-faq mt-12"
    >
      <Heading
        v-if="section.title"
        :level="2"
        :title="isI18nObject ? section.title : rt(section.title)"
        class="kft-heading--left kft-heading--no-underline title mb-4"
      />

      <div
        :id="`kft_accordion_${i}`"
        class="accordion-icon-toggle kft-accordion"
      >
        <!--begin::Item-->
        <details
          v-for="(obj, j) in section.questions"
          :key="`kft-faq-question-${i}-${j}`"
          class="border-b py-4 border-gray-200"
          open
          itemprop="mainEntity"
          itemscope
          itemtype="https://schema.org/Question"
        >
          <summary class="select-none my-4 inline cursor-pointer">
            <Heading
              :level="3"
              h-class="text-h6 font-normal"
              :title="isI18nObject ? obj.question : rt(obj.question)"
              :use-h-tag="true"
              class="kft-heading--left my-2"
              itemprop="name"
            />
          </summary>
          <div
            class="text-slate-600 my-4 mb-8"
            itemprop="acceptedAnswer"
            itemscope
            itemtype="https://schema.org/Answer"
          >
            <div
              itemprop="text"
              v-html="isI18nObject ? obj.answer : rt(obj.answer)"
            />
          </div>
        </details>
        <!--end::Item-->
      </div>
    </div>
    <!--end::Accordion-->
  </div>
</template>

<script lang="ts" setup>
const { isI18nObject } = defineProps(['content', 'isI18nObject'])
const { rt } = useI18n()
</script>

<style lang="css" scoped>
.kft-accordion {
  &__item {
    border-bottom: 1px solid $gray-ultralight;
    padding: 2rem 0;

    &__header {
      cursor: pointer;
    }
  }
}
</style>
